var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"hero-b-g-image",style:(_vm.styleObject)},[_c('LogoPadded',{staticClass:"logo"}),_c('NavLinks',{staticClass:"nav"}),_c('div',{staticClass:"slogan"},[_c('div',{staticClass:"slogan__content"},[_vm._t("slogan")],2)])],1)}
var staticRenderFns = []

export { render, staticRenderFns }